import { createContext } from "react";

const mobMenuContext= createContext();

export default mobMenuContext;